'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _class, _temp;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactBootstrap = require('react-bootstrap');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * backdrop: 'static' | true | false
 */
var ModalCustom = (_temp = _class = function (_Component) {
  (0, _inherits3.default)(ModalCustom, _Component);

  function ModalCustom() {
    (0, _classCallCheck3.default)(this, ModalCustom);
    return (0, _possibleConstructorReturn3.default)(this, (ModalCustom.__proto__ || (0, _getPrototypeOf2.default)(ModalCustom)).apply(this, arguments));
  }

  (0, _createClass3.default)(ModalCustom, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          show = _props.show,
          onHide = _props.onHide,
          full = _props.full,
          closeButton = _props.closeButton,
          backdrop = _props.backdrop,
          title = _props.title,
          message = _props.message,
          button = _props.button,
          headerOff = _props.headerOff,
          desktopMode = _props.desktopMode;

      var drop = true;
      if (backdrop === 'static') {
        drop = backdrop;
      }
      var mainClass = 'modalLookme ' + (full ? 'full' : '') + ' modal';
      if (desktopMode) {
        mainClass = 'modalLookme desktop modal';
      }

      return _react2.default.createElement(
        _reactBootstrap.Modal,
        { show: show, onHide: onHide, bsClass: mainClass, backdrop: drop },
        !headerOff && _react2.default.createElement(
          'div',
          { className: 'modal-lookme-header ' + (title ? title.type : '') },
          title && _react2.default.createElement(
            'div',
            null,
            title.text
          ),
          closeButton && _react2.default.createElement(
            'div',
            { className: 'btn-close', onClick: onHide },
            ' ',
            _react2.default.createElement('i', { className: 'fa fa-close' })
          )
        ),
        _react2.default.createElement(
          _reactBootstrap.Modal.Body,
          null,
          message && message.length && _react2.default.createElement(
            'div',
            { className: 'modal-message' },
            message.map(function (v, i) {
              return _react2.default.createElement(
                'div',
                { key: 'message_' + i, className: 'message ' + v.type },
                v.text
              );
            })
          ),
          this.props.children
        ),
        !!(button && button.length) && _react2.default.createElement(
          'div',
          { className: 'modal-lookme-footer' },
          button.map(function (v, i) {
            return v && v.text && _react2.default.createElement(
              'div',
              {
                key: 'btnLookme_' + i,
                className: 'btn-lookme ' + v.type,
                onClick: v.onClick
              },
              !!v.iconFont && _react2.default.createElement('i', { className: v.iconFont }),
              v.text
            );
          })
        )
      );
    }
  }]);
  return ModalCustom;
}(_react.Component), _class.propTypes = {
  show: _react.PropTypes.bool,
  full: _react.PropTypes.bool,
  closeButton: _react.PropTypes.bool,
  children: _react.PropTypes.object,
  message: _react.PropTypes.array,
  button: _react.PropTypes.array,
  title: _react.PropTypes.object,
  backdrop: _react.PropTypes.string,
  // iconFont: PropTypes.string,
  headerOff: _react.PropTypes.bool,
  desktopMode: _react.PropTypes.bool,
  // @action
  onHide: _react.PropTypes.func
}, _temp);
exports.default = ModalCustom;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/Mobile/Common/Booking/ModalCustom.js
// module id = 1561
// module chunks = 0